/**
 * @packageDocumentation
 * @module Datetime
 */
/**
 * Function to check if the format is AM/PM or not
 * @param format: format string to check
 *
 * @return boolean
 */
var isAMPM = function (format) { return RegExp('[(a*)\\b]', 'gi').test(format); };
export default isAMPM;
//# sourceMappingURL=isAMPMFormat.js.map